import type { ActionHandlerComponent } from "./types";

export class ActionHandlerRegistry {
  private handlers = new Map<string, ActionHandlerComponent[]>();

  register(type: string, component: ActionHandlerComponent): void {
    const existing = this.handlers.get(type) ?? [];
    this.handlers.set(type, [...existing, component]);
  }

  getHandlers(type: string): ActionHandlerComponent[] {
    return this.handlers.get(type) ?? [];
  }

  clear(): void {
    this.handlers.clear();
  }
}
